module.exports = __webpack_public_path__ + "img/arrow-up-right.a3041527.svg";